// extracted by mini-css-extract-plugin
export default {"collectionList":"ParentPlaylistPage-module__collectionList","playlistCard":"ParentPlaylistPage-module__playlistCard"};